module.exports = __webpack_public_path__ + "static/hackathon-sponsor-tiers-fdcd00056e4efd3746aa5280ab87c4e1.png";